import { Component, OnInit } from '@angular/core';
import { PoBreadcrumb, PoNotificationService } from '@po-ui/ng-components';
import { XmlService } from '../../services/xml.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-contabil-outros',
  templateUrl: './contabil-outros.component.html',
  styleUrls: ['./contabil-outros.component.css'],
  standalone: false
})
export class ContabilOutrosComponent implements OnInit {

  isLoading: boolean = false;
  xmlApiUrl = `${environment.apiUrl}${environment.versionApi}/xml/classifica-entradas-cte`;

  readonly breadcrumb: PoBreadcrumb = {
      items: [{ label: 'Home', link: '/home' }, { label: 'Contabilidade' }, { label: 'Outros' }]
  };

  constructor(private readonly poNotificationService: PoNotificationService,
              private readonly xmlservice: XmlService
  ) { }

  ngOnInit() {
  }

  corrigeTxt(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (!input.files || input.files.length === 0) {
      alert('Nenhum arquivo selecionado.');
      return;
    }

    const file = input.files[0];

    const reader = new FileReader();

    reader.onload = () => {
      let text = reader.result as string;

      // Remove caracteres indesejados, exceto: letras, números, espaço, pipe, ponto, vírgula e hífen
      text = text.replace(/[^\w\s|.,-]/g, '');

      // Remove tabulações
      text = text.replace(/\t/g, '');

      // Cria o novo arquivo com conteúdo processado
      const blob = new Blob([text], { type: 'text/plain;charset=utf-8' });
      const url = URL.createObjectURL(blob);

      // Cria um link para download automático
      const a = document.createElement('a');
      a.href = url;
      a.download = file.name.replace(/\.txt$/, '') + '._convertido.txt';
      a.click();

      // Libera o objeto URL
      URL.revokeObjectURL(url);

      alert('Arquivo convertido com sucesso!');
    };

    reader.onerror = () => {
      alert('Erro ao ler o arquivo.');
    };

    reader.readAsText(file);
  }

  testXml(event: any) {
    const arquivoZip = event.target.files[0]; // Obtém o arquivo selecionado pelo usuário

    if (!arquivoZip) {
      this.poNotificationService.error("Nenhum arquivo foi selecionado.");
      return;
    }

    this.isLoading = true;

    this.xmlservice.processarZip(arquivoZip).subscribe(
      (response) => {
        // Cria um link para download do arquivo ZIP retornado
        const url = window.URL.createObjectURL(response);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'ArquivosModificados.zip');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        this.poNotificationService.success("Arquivo processado com sucesso!");
        this.isLoading = false;
      },
      (error) => {
        console.error("Erro ao processar o arquivo:", error);
        this.poNotificationService.error("Erro ao processar o arquivo.");
        this.isLoading = false;
      }
    );
  }

}
